import { render, staticRenderFns } from "./system_info.vue?vue&type=template&id=33901c68&scoped=true&"
import script from "./system_info.vue?vue&type=script&lang=js&"
export * from "./system_info.vue?vue&type=script&lang=js&"
import style0 from "./system_info.vue?vue&type=style&index=0&id=33901c68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33901c68",
  null
  
)

export default component.exports